import Vue from 'vue'
import bootstrap from 'bootstrap-vue'

Vue.use(bootstrap)
